import React from 'react';
import withDrawingContainer, { withDrawingContainerProps } from './withDrawingContainer';
import { Rect, Text } from 'react-konva';
import {
  DrawingType,
  LightPathDrawing as LightPathDrawingType,
  RoiUpdateDetails,
} from '../constants';
import { getContinuousLightPathSize, getDiscreteLightPathSize } from '../utils';
import LightPathDrawing from './lightPathDrawing';

interface Props extends withDrawingContainerProps {
  isImagingEnabled: boolean;
  regionName: string;
  lightPaths: LightPathDrawingType[];
  shouldRenderLightPaths: boolean;
}

const renderLightPaths = (
  lightPaths: LightPathDrawingType[],
  roiX: number,
  roiY: number,
  roiWidth: number,
  roiHeight: number,
) => {
  return lightPaths.map((lightPath, index) => {
    let newlightPath: LightPathDrawingType;
    if (lightPath.isDiscrete === false) {
      newlightPath = getContinuousLightPathSize(
        lightPath,
        roiWidth,
        roiHeight,
      ) as LightPathDrawingType;
    } else {
      newlightPath = getDiscreteLightPathSize(lightPath, roiWidth, roiHeight);
    }

    const { id, rectangleF, color, name } = newlightPath;
    const { width: lpWidth, height: lpHeight } = rectangleF;
    const calcxCenter = roiX - newlightPath.rectangleF.width / 2 + roiWidth / 2;
    const calcyCenter = roiY - newlightPath.rectangleF.height / 2 + roiHeight / 2;

    newlightPath.rectangleF.x = calcxCenter;
    newlightPath.rectangleF.y = calcyCenter;

    return (
      <LightPathDrawing
        key={index}
        id={id}
        x={(roiX - calcxCenter) * -1}
        y={(roiY - calcyCenter) * -1}
        width={lpWidth}
        height={lpHeight}
        color={color}
        name={name}
      />
    );
  });
};

const RoiDrawing = (props: Props) => {
  const {
    id,
    x,
    y,
    width,
    height,
    regionName,
    isImagingEnabled,
    isSelected,
    rectRef,
    lightPaths,
    shouldRenderLightPaths,
  } = props;
  const fSize = width / 5 > 12 ? 12 : width / 5;
  const ligthPathComponent =
    shouldRenderLightPaths && lightPaths?.length
      ? renderLightPaths(lightPaths, x, y, width, height)
      : null;

  return (
    <>
      <Rect
        id={`roidrawing-rect-${id}`}
        ref={rectRef}
        width={width}
        height={height}
        fill={isSelected ? 'gray' : null}
        stroke={isSelected || isImagingEnabled ? 'red' : 'white'}
        strokeWidth={2}
        opacity={isSelected ? 0.5 : 1}
        shadowBlur={isSelected ? 10 : 0}
        shadowColor={isSelected ? 'black' : ''}
        shadowOpacity={isSelected ? 5 : 0}
        shadowEnabled={isSelected ? true : false}
      />
      <Text
        id={`roidrawing-text-${id}`}
        x={5}
        y={5}
        fill={isSelected ? 'black' : 'white'}
        fontSize={fSize}
        textAnchor="middle"
        text={regionName}
      />
      {ligthPathComponent}
    </>
  );
};

const moveActionPreProcessor = (props: Props, x: number, y: number): RoiUpdateDetails => {
  const { x: transformedX, y: transformedY } =
    props.tpObject.convertRectangleDrawingForDb(x, y, props.width, props.height);
  return {
    x,
    y,
    width: props.width,
    height: props.height,
    dbXCenterOffset: transformedX,
    dbYCenterOffset: transformedY,
  };
};

const transformActionPreProcessor = (
  props: Props,
  width: number,
  height: number,
): RoiUpdateDetails => {
  const { width: transformedWidth, height: transformedHeight } =
    props.tpObject.ConvertPointsToROI({
      xWidth: width,
      yHeight: height,
    });
  return { width, height, dbWidth: transformedWidth, dbHeight: transformedHeight };
};
export default withDrawingContainer(
  RoiDrawing,
  DrawingType.ROI,
  moveActionPreProcessor,
  transformActionPreProcessor,
);
  